import { Injectable, signal } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../utils/utils.service';
import { A } from '@angular/cdk/activedescendant-key-manager.d-Bjic5obv';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RelationshipService {
  private _journeyList: any = signal([]);
  journeyConfig: any = signal({});
  unique_field_id: any = 'tag_private_user_name';
  unique_field_type: any = 'tag';
  min_doc_count:number = 0;
  constructor(
    public _utilService: UtilsService
  ) { }


  updateConfig(journeyConfig: any) {
    this.unique_field_id = journeyConfig?.unique_field_id
    this.min_doc_count = journeyConfig?.min_doc_count
    this.unique_field_type = journeyConfig?.unique_field_type
    this.journeyConfig.set(journeyConfig);
  } 

  getJourneyConfigByQuery(query: any) {
    try {
      const url = this._utilService.apiUrlGeneration(environment.analyticsV1, environment.analyticsV1.journeyConfig);
      return this._utilService.getAPICall(url, this._utilService.setHeaderWithParams(query));
    } catch (error) {
      console.error('An unexpected error occurred in getJourneyConfigByQuery:', error);
      return throwError('An unexpected error occurred in getJourneyConfigByQuery');
    }
  }
  getJourneyConfigList(accountId: string) {
    try {
      const url = this._utilService.apiUrlGeneration(environment.analyticsV1, environment.analyticsV1.journeyConfigList);
      return this._utilService.getAPICall(url, this._utilService.setHeaderWithParams({account_id: accountId}));
    } catch (error) {
      console.error('An unexpected error occurred in getJourneyList:', error);
      return throwError('An unexpected error occurred in getJourneyList');
    }
  }

  removeJourneyConfig(account_id: string, version: string) {
    try {
      const url = this._utilService.apiUrlGeneration(environment.analyticsV1, environment.analyticsV1.removeJourneyConfig);
      return this._utilService.postAPICall(url,{account_id:account_id,version:version}, this._utilService.setHeaders());
    } catch (error) {
      console.error('An unexpected error occurred in removeJourneyConfig:', error);
      return throwError('An unexpected error occurred in removeJourneyConfig');
    }
  }

  saveJourneyConfig(accountId: string, journeyConfig: any) {
    try {
      const url = this._utilService.apiUrlGeneration(environment.analyticsV1, environment.analyticsV1.journeyConfig);
      return this._utilService.postAPICall(url, {account_id: accountId, journey_config: journeyConfig}, this._utilService.setHeaders());
    } catch (error) {
      console.error('An unexpected error occurred in saveJourneyConfig:', error);
      return throwError('An unexpected error occurred in saveJourneyConfig');
    }
  }

  getRelationshipOverallSummary(requestbody: any) {
    try {
      const url = this._utilService.apiUrlGeneration(environment.analyticsV1, environment.analyticsV1.relationshipOverallSummary);
      return this._utilService.postAPICall(url, requestbody, this._utilService.setHeaders());
    } catch (error) {
      console.error('An unexpected error occurred in getRelationshipOverallSummary:', error);
      return throwError('An unexpected error occurred in getRelationshipOverallSummary');
    }
  }

  getRelationshipTrendSummary(requestbody: any) {
    try {
      const url = this._utilService.apiUrlGeneration(environment.analyticsV1, environment.analyticsV1.relationshipTrendSummary);
      return this._utilService.postAPICall(url, requestbody, this._utilService.setHeaders());
    } catch (error) {
      console.error('An unexpected error occurred in getRelationshipTrendSummary:', error);
      return throwError('An unexpected error occurred in getRelationshipTrendSummary');
    }
  }

  getRelationshipJourneySummary(requestbody: any) {
    try {
      const url = this._utilService.apiUrlGeneration(environment.analyticsV1, environment.analyticsV1.relationshipJourneySummary);
      return this._utilService.postAPICall(url, requestbody, this._utilService.setHeaders());
    } catch (error) {
      console.error('An unexpected error occurred in getRelationshipJourneySummary:', error);
      return throwError('An unexpected error occurred in getRelationshipJourneySummary');
    }
  }

  getRelationshipDetailedSummary(requestbody: any) {
    try {
      const url = this._utilService.apiUrlGeneration(environment.analyticsV1, environment.analyticsV1.relationshipDetailedSummary);
      return this._utilService.postAPICall(url, requestbody, this._utilService.setHeaders());
    } catch (error) {
      console.error('An unexpected error occurred in getRelationshipDetailedSummary:', error);
      return throwError('An unexpected error occurred in getRelationshipDetailedSummary');
    }
  }

  getUserFeedList(requestbody: any) {
    try {
      const url = this._utilService.apiUrlGeneration(environment.analyticsV1, environment.analyticsV1.customerFeedList);
      return this._utilService.postAPICall(url, requestbody, this._utilService.setHeaders());
    } catch (error) {
      console.error('An unexpected error occurred in getCustomerFeedList:', error);
      return throwError('An unexpected error occurred in getCustomerFeedList');
    }
  }

  getCustomerList(requestbody: any) {
    try {
      const url = this._utilService.apiUrlGeneration(environment.analyticsV1, environment.analyticsV1.relationshipCustomerList);
      return this._utilService.postAPICall(url, requestbody, this._utilService.setHeaders());
    } catch (error) {
      console.error('An unexpected error occurred in getCustomerList:', error);
      return throwError('An unexpected error occurred in getCustomerList');
    }
  }
}
